import BookQuizQuestion from "./BookQuizQuestion";

export default BookQuizQuestion;
